<div class="m-t-lg" *ngIf="false">
  <h3 class="inline-block w-50 disabled m-t-xs">
    {{ aemContent?.plans }}
  </h3>
</div>
<div class="m-t-lg">
  <p class="alert-text m-t-lg" *ngIf="false">
    <i class="fa fa-flag def alert-icon"></i>
    {{ aemContent?.plansAndServicesClearedNotification }}
  </p>
</div>
<div class="m-t-lg" *ngIf="!focusedTileIdDetails?.disableIDontNeedCheckbox">
  <div *ngIf="noPlanNeeded">
    <p class="alert-text m-t-lg" *ngIf="isDeviceSelected; else noDeviceSelected">
      <i class="fa fa-flag def alert-icon"></i>
      {{ aemContent?.devicePriceChangeNotification }}
    </p>
    <ng-template #noDeviceSelected>
      <p class="alert-text m-t-lg">
        <i class="fa fa-flag def alert-icon"></i>
        {{ aemContent?.pricingChangeWithoutServiceMessage }}
      </p>
    </ng-template>
  </div>
</div>
<div class="m-t-lg">
  <p class="alert-text m-t-lg" *ngIf="false">
    <i class="fa fa-flag def alert-icon"></i>{{ aemContent?.pricingChangeWithoutServiceMessage }}
  </p>
</div>
<!-- <div class="m-t-xl">
  <tmo-checkbox [id]="'noPlanNeeded'" aria-label="{{aemContent?.planNotRequiredMessage}}" [name]="'noPlan'"
    [checked]="noPlanNeeded" (change)="onCheckBoxClick($event.target.checked)" [disabled]="disableCheckbox">
    {{aemContent?.planNotRequiredMessage}}
  </tmo-checkbox>
</div> -->
<div class="m-t-xl">
  <button
    class="btn btn-primary m-t-lg"
    [id]="'noPlanNeeded'"
    aria-label="{{ aemContent?.planNotRequiredMessage }}"
    [name]="'noPlan'"
    [checked]="noPlanNeeded"
    (change)="onCheckBoxClick($event.target.checked)"
    [disabled]="disableCheckbox"
  >
    {{ aemContent?.planNotRequiredMessage }}
  </button>
</div>

<div class="row m-t-xl">
  <div class="col-12">
    <hr class="divider" />
  </div>
</div>
<tmo-static-modal
  id="no-plan-needed-modal"
  [modal]="noPlan"
  [displayModal]="isNoPlanNeededCheck"
  (onClose)="closeModal(true)"
  (onSelect)="planCheck($event)"
>
</tmo-static-modal>
